module.exports = __webpack_public_path__ + "img/img-intro1@2x.8307c148.jpg";